import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { LANGUAGE_OPTIONS } from '@/i18n';

// Radix Select can't use an empty string as an item value
export const DEFAULT_LANGUAGE = 'default';

interface UserLanguageSelectProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
}

export function UserLanguageSelect({ id, value, onChange }: UserLanguageSelectProps) {
  const { t } = useTranslation();
  return (
    <div className="grid gap-2">
      <Label htmlFor={id}>{t('users.language')}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger id={id}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={DEFAULT_LANGUAGE}>{t('users.languageDefault')}</SelectItem>
          {LANGUAGE_OPTIONS.map((o) => (
            <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
